import { render } from "./AppRate.vue?vue&type=template&id=e6160f74"
import script from "./AppRate.vue?vue&type=script&lang=js"
export * from "./AppRate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__